// Projection de lecture uniquement : ne jamais trier les tableaux Vuex utilisés pour facturer.
function operationDate(operation) {
    const raw = operation.date || operation.created_at
    if (typeof raw !== 'string' || !/^\d{4}-\d{2}-\d{2}(?:$|[T ])/.test(raw)) return Infinity
    const normalized = raw.trim().replace(' ', 'T')
    const timestamp = Date.parse(normalized.length === 10 ? normalized + 'T00:00:00Z' :
        (/(?:Z|[+-]\d{2}:?\d{2})$/.test(normalized) ? normalized : normalized + 'Z'))
    return Number.isFinite(timestamp) ? timestamp : Infinity
}

export function invoiceGroupsInDisplayOrder(groups) {
    const lines = []
    const sourceGroups = Array.isArray(groups) ? groups : []
    sourceGroups.forEach((group, groupIndex) => {
        const prestations = Array.isArray(group.prestations) ? group.prestations : []
        prestations.forEach(prestation => {
            lines.push({ group, groupIndex, prestation, index: lines.length, date: operationDate(prestation),
                consultation: (prestation.data_type || group.data_type) === 'bon_consultation' })
        })
    })
    lines.sort((a, b) => Number(b.consultation) - Number(a.consultation) ||
        (a.date === b.date ? 0 : a.date < b.date ? -1 : 1) || a.index - b.index)

    // Une catégorie peut réapparaître si ses prestations encadrent une autre catégorie.
    // Chaque sous-total concerne seulement les lignes visibles de ce segment.
    const result = []
    lines.forEach(line => {
        let segment = result[result.length - 1]
        if (!segment || segment.sourceGroupIndex !== line.groupIndex) {
            segment = { ...line.group, sourceGroupIndex: line.groupIndex, prestations: [], sous_total: 0 }
            result.push(segment)
        }
        segment.prestations.push(line.prestation)
        const paid = Number(line.prestation.montant_paye) || 0
        segment.sous_total += line.prestation.data_type === 'apport_social' ? -paid : paid
        segment.can_show_subtotal = segment.prestations.length > 1
    })
    return result
}
